module.exports = __webpack_public_path__ + "static/media/GMA-S2100-4AER_OR13_beautyshot1.53740e17.jpg";